import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

interface Subject {
    id: number;
    name: string;
    // Add other subject fields as needed
}

interface CourseSubjectsState {
    data: Subject[] | null;
    isLoading: boolean;
    error: any;
}

const initialState: CourseSubjectsState = {
    data: null,
    isLoading: false,
    error: null,
};

const courseSubjectsSlice = createSlice({
    name: "CourseSubjectsSlice",
    initialState,
    reducers: {
        fetchList: (state, action: PayloadAction<any | undefined>) => {
            state.isLoading = true;
            state.error = null;
        },
        successCourseSubjects: (state, action: PayloadAction<Subject[]>) => {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
        },
        failureCourseSubjects: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchList, successCourseSubjects, failureCourseSubjects } = courseSubjectsSlice.actions;
export default courseSubjectsSlice.reducer;
